<template>
  <!-- :style="{
          transform: isTrue ? `translateX(-${tanslateIndex * 304}px)` : ``,
        }" -->
  <div style="position: relative">
    <div style="overflow: hidden; padding: 5px 0">
      <div class="rotation-box" ref="transiton">
        <div
          class="rotation-item"
          v-for="(v, i) in list"
          :key="i"
          :class="{ rotationActive: ratationCurrent == i }"
          @mouseover="overItem(i)"
          @mouseout="outItem"
          @click="goDetail(i)"
        >
          <div class="rotation-head">
            <img  :src="FILE_BASE_URL+v.image"  />
          </div>
          <div :style="{ color: ratationCurrent == i ? '#C1141E' : '#333333' }">
            {{v.name}}
          </div>
          <div>
            {{v.introdution}}
          </div>
        </div>
      </div>
    </div>
    <div
      class="lefticon"
      @click="prevClick"
      @mouseover="iconLeftMouseOver"
      @mouseout="iconLeftMouseOut"
    >
      <img v-if="isLeftMouseOver" src="../../assets/zuohong1.svg" alt="" />
      <img v-else src="../../assets/iconzuo1.svg" alt="" />
    </div>
    <div
      class="righticon"
      @click="nextClick"
      @mouseover="iconRightMouseOver"
      @mouseout="iconRightMouseOut"
    >
      <img v-if="isRightMouseOver" src="../../assets/youhong1.svg" alt="" />
      <img v-else src="../../assets/youicon1.svg" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isTrue: false,
      ratationCurrent: -1,
      tanslateIndex: 0,
      show: false,
      isTransition: false,
      list: [],
      isLeftMouseOver: false,
      isRightMouseOver: false,
      timer: "",
      preIndex: 0,
      FILE_BASE_URL:this.$API.FILE_BASE_URL
    };
  },
  mounted() {
    this.startAuto();
    this.loadVolunteer();
  },
  destroyed(){
    clearInterval(this.timer)
  },
  methods: {
    startAuto() {
      this.timer = setInterval(() => {
        this.isTrue = true;
        this.tanslateIndex++;
        this.$refs.transiton.style.transform = `translate(-${
          this.tanslateIndex * 295
        }px)`;
        // if (this.tanslateIndex >= this.list.length - 3) {
        //   this.tanslateIndex = 0;
        //   //  this.list.unshift()
        // }
      }, 3000);
    },
    /**志愿者风采 */
    loadVolunteer(){
      let params = {
        'type': 0,
        pageNo:1,
        pageSize:10
      }
      this.$API.queryVolunteerPageList(params).then(res=>{
        this.list = res.result.records
      })
    },
    goDetail(i){
        // 详情数据存本地存储，详情页直接本地存储获取
        localStorage.setItem('navList',JSON.stringify(this.list));
        this.$router.push({
         path:'/volunteer/demeanor/detail?index=5&title=志愿之家&curIndex=0&type=5&infoIndex=' + i
      })
      },
    nextClick() {
      this.isTrue = true;
      this.tanslateIndex++;
      this.ratationCurrent++;
      this.$refs.transiton.style.transform = `translate(-${
        this.tanslateIndex * 295
      }px)`;
    },
    prevClick() {
      this.tanslateIndex--;
      this.$refs.transiton.style.transform = `translate(-${
        this.tanslateIndex * 295
      }px)`;
      
      if(this.tanslateIndex<0){
        this.tanslateIndex =0
      }
    },
    overItem(i) {
      this.ratationCurrent = i;
      clearInterval(this.timer);
    },
    outItem() {
      this.ratationCurrent = -1;
      this.startAuto();
    },
    clickItem(i) {
      this.ratationCurrent = i;
    },
    iconLeftMouseOver() {
      this.isLeftMouseOver = true;
      clearInterval(this.timer);
    },
    iconLeftMouseOut() {
      this.isLeftMouseOver = false;
      this.startAuto();
    },
    iconRightMouseOver() {
      this.isRightMouseOver = true;
      clearInterval(this.timer);
    },
    iconRightMouseOut() {
      this.isRightMouseOver = false;
      this.startAuto();
    },
  },
  watch: {
    tanslateIndex(val) {
      if (val > 0 ) {
        this.list.push(this.list[val - 1]);
       
      }
    
     
    },
   
  },
};
</script>

<style scoped lang="scss">
.lefticon {
  position: absolute;
  left: -10%;
  top: 45%;
}
.righticon {
  position: absolute;
  right: -10%;
  top: 45%;
}
.rotationActive {
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  transition: 1s;
}
.rotation-box {
  width: 1210px;
  display: flex;
  justify-content: flex-start;
  transition: 1s;
  padding: 0 5px;
  &.transition {
    transition-delay: 2s;
  }
  > div:first-child {
    //  margin-left: 5px;
  }
  > div:not(:first-child) {
     margin-left: 10px;
  }
}
.rotation-item {
  flex: 0 0 auto;
  width: 285px;
  height: 372px;
  padding-top: 20px;
  // margin-right: 17px;

  .rotation-head {
    text-align: center;
    img {
      width: 200px;
      height: 200px;
      border-radius: 50%;
    }
  }
  > div:nth-child(2) {
    font-size: 18px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
    text-align: center;
    margin-top: 20px;
  }
  > div:nth-child(3) {
    margin-top: 20px;
    padding: 0 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    color: #777777;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>